import LayoutAuth from '@/views/auth/the-layout.vue'

export default {
  path: '/auth',
  component: LayoutAuth,
  children: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/login/page-login.vue'),
      meta: { title: 'Login' },
    },
  ],
}
